import React from 'react';
import NewsDisplay from 'components/news/newsDisplay';
import Route from 'enum/route.enum';
import { Navigate } from 'react-router-dom';

import { Container, ContainerModalInternal, Footer } from 'components/styles/Common.styled';
import BackCursor from 'components/common/nav/backCursor';
import { translate as t } from 'utils/i18n';
import MenuModalWithActiveItem from 'components/common/MenuModalWithActiveItem';
import NewsContainer from './NewsContainer';

class newsList extends NewsContainer {
  render() {
    const { redirectBack, loading, showError, items, focusIndex } = this.state;

    if (redirectBack) {
      return <Navigate to={Route.route.LANDING} />;
    }

    return (
      <>
        <BackCursor></BackCursor>
        <Container>
          {items.length <= 0 && !loading ? (
            <div className={`has-text-danger has-text-centered`}>
              <p className={'is-size-4 has-text-bold'}>{t('News.newsError')}</p>
            </div>
          ) : items.length <= 0 && showError && loading ? (
            <div className={`has-text-danger has-text-centered`}>
              <p className={'is-size-4 has-text-bold'}>
                The selected language is not configured yet.
              </p>
            </div>
          ) : (
            items.length && (
              <ContainerModalInternal>
                <NewsDisplay news={items[focusIndex]}></NewsDisplay>
              </ContainerModalInternal>
            )
          )}
        </Container>

        {items.length > 0 && !showError && (
          <Footer>
            <MenuModalWithActiveItem
              items={items.map((item) => ({
                text: item.latest_news || '',
                id: item.locale_latest_news?.id || '',
                image: item.image || null,
                active: item.active,
              }))}
              activeIndex={focusIndex}
              onItemClick={(item) => this.clickHandler(null, item)}
              showImages={true}
            />
          </Footer>
        )}
      </>
    );
  }
}

export default newsList;
